/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcAgStickyDirective} from './fc-ag-sticky.directive';

/**
 * Fc Context module with Angular.
 */
@NgModule({
    declarations: [
        FcAgStickyDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FcAgStickyDirective
    ]
})
export class FcAgStickyModule {
}
